import React, {Component} from "react";
import * as R from "ramda";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import withFormGroup from "../../../../modules/commons/withFormGroup";
import Api from "../../../../Services/Api";
import {mapToObjectDDL, mapToSelectOption} from "../../../common/mapper";
import {ACTIVITY_TYPE} from "../../../common/Constants";

class MasterLocatorModifying extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataCabang: [],
            dataLocation: [],
        };
    }

    componentDidMount = async () => {
        await this.fetchDataCabang();
        let dataCabang = this.state.dataCabang.find(item => item.kodeCabang === this.props.controls.kodeCabang.value)
        let kodeCabangDDL = dataCabang ? mapToSelectOption(dataCabang.kodeCabang) : null;
        this.props.setValue("kodeCabang", kodeCabangDDL);
    }

    handleSubmit = () => {
        if (this.props.validate()) {
            this.props.onSubmit(this.props.controls);
        }
    };

    fetchDataCabang = async () => {
        try {
            const response = await Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang();
            if (response.ok) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataCabang: response.data.data,
                }));
            }
        } catch (error) {
            console.log("error: ", error);
        }
    }

    render() {
        return (
            <SimpleModal
                title="Form Lokasi"
                visible={this.props.visible}
                onClickClose={() => this.props.onClickClose()}
                content={
                    <ModalContainer>
                            <SimpleInput
                                id="input_text_kode_lokasi"
                                name="kodeLocation"
                                label="Kode Lokasi"
                                mandatory
                                errorMessage={this.props.errors.kodeLocation}
                                value={this.props.controls.kodeLocation.value}
                                readOnly={R.equals(this.props.activityType, ACTIVITY_TYPE.UPDATE)}
                                onChange={({target}) =>
                                    this.props.setValue(target.name, target.value)
                                }
                            />
                            <SimpleDDL
                                id="input_text_kode_cabang"
                                name="kodeCabang"
                                label="Kode Cabang"
                                box="search"
                                isClearable
                                mandatory
                                errorMessage={this.props.errors.kodeCabang}
                                options={this.state.dataCabang ? this.state.dataCabang.map(
                                    item => mapToObjectDDL(
                                        item.kodeCabang,
                                        item.kodeCabang
                                    )) : null}
                                value={this.props.controls.kodeCabang.value}
                                onChange={(value, {name}) =>
                                    this.props.setValue(name, value)
                                }
                            />
                            <SimpleInput
                                id="input_text_nama_lokasi"
                                name="nameLocation"
                                label="Nama Lokasi"
                                mandatory
                                errorMessage={this.props.errors.nameLocation}
                                value={this.props.controls.nameLocation.value}
                                onChange={({target}) =>
                                    this.props.setValue(target.name, target.value)
                                }
                            />
                            <div style={{ textAlign: "right" }}>
                                <SimpleButton onClick={this.handleSubmit}>Simpan</SimpleButton>
                            </div>
                    </ModalContainer>
                }
            />
        );
    }
}

export default withFormGroup(MasterLocatorModifying);